(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pv-styles"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__pvReveal) return;
    window.__pvReveal = true;
    if (window.Shopify && window.Shopify.designMode) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const selector = [
      '.shopify-section ~ .shopify-section .section > .pv-inner',
      '.shopify-section ~ .shopify-section .section > .pv-included',
      '.shopify-section ~ .shopify-section .section > .pv-cta',
    ].join(',');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    const scan = () => {
      document.querySelectorAll(selector).forEach((element) => {
        if (element.classList.contains('pv-reveal')) return;
        element.classList.add('pv-reveal');
        observer.observe(element);
      });
    };
    const start = () => {
      document.documentElement.classList.add('pv-motion');
      scan();
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
